import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Home, ArrowLeft } from "lucide-react";
import { SEO } from "@/components/SEO";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <SEO
        title="Pagina non trovata (404)"
        description="La pagina richiesta non esiste. Torna alla home di FIABA ETS o esplora le sezioni principali del sito."
        path={location.pathname}
      />
      <section className="flex min-h-[70vh] items-center justify-center bg-subtle px-4">
        <div className="text-center max-w-xl">
          <p className="text-secondary font-semibold tracking-widest text-sm uppercase mb-3">
            Errore 404
          </p>
          <h1 className="heading-lg text-primary mb-4">Pagina non trovata</h1>
          <p className="text-muted-foreground mb-8 leading-relaxed">
            La pagina che stai cercando non esiste o è stata spostata.
            Puoi tornare alla home oppure esplorare le sezioni principali del sito FIABA ETS.
          </p>
          <div className="flex flex-wrap gap-3 justify-center">
            <Button asChild>
              <Link to="/" aria-label="Torna alla home">
                <Home className="mr-2 h-4 w-4" aria-hidden="true" />
                Torna alla home
              </Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/contatti">
                <ArrowLeft className="mr-2 h-4 w-4" aria-hidden="true" />
                Contattaci
              </Link>
            </Button>
          </div>
          <nav aria-label="Sezioni principali" className="mt-10 flex flex-wrap gap-x-5 gap-y-2 justify-center text-sm">
            <Link to="/chi-siamo" className="text-primary hover:text-secondary underline-offset-4 hover:underline">Chi siamo</Link>
            <Link to="/area-tecnica" className="text-primary hover:text-secondary underline-offset-4 hover:underline">Area Tecnica</Link>
            <Link to="/fiaba-day" className="text-primary hover:text-secondary underline-offset-4 hover:underline">FIABA Day</Link>
            <Link to="/segnalazioni" className="text-primary hover:text-secondary underline-offset-4 hover:underline">Segnalazioni</Link>
            <Link to="/diventa-socio" className="text-primary hover:text-secondary underline-offset-4 hover:underline">Diventa socio</Link>
          </nav>
        </div>
      </section>
    </>
  );
};

export default NotFound;
